import { render, staticRenderFns } from "./Isim.vue?vue&type=template&id=fecdb014&scoped=true&"
import script from "./Isim.vue?vue&type=script&lang=js&"
export * from "./Isim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecdb014",
  null
  
)

export default component.exports